<template>
    <input type='tel' class='form-control' @input="$emit('input', $event.target.value)" />
</template>

<script>
export default {
    name : "InputTel",
    props: {
        field: Object
    }
}
</script>
